import axios from "axios";
import { environment } from "../../../environments/environment";

export const getDiscrepancySvc = (page, pageSize, search, order, body) => {
  let params = new URLSearchParams();
  params.append("page", page);
  params.append("pageSize", pageSize);
  params.append("search", search);
  params.append("orderBy", order);

  return axios.post(environment.getDiscrepancy + params, body);
};

export const getDiscrepancyMessagesSvc = (discrepancyId, channel) => {
  let params = new URLSearchParams();
  params.append("discrepancyId", discrepancyId);
  params.append("channel", channel);
  return axios.get(
    "https://kodo-develop.aspsols.com" +
      environment.getDiscrepancyMessages +
      params
  );
};

export const sendDiscrepancyMessageSvc = (body) => {
  return axios.post(environment.sendDiscrepancyMessage, body);
};
